var exports = {
  "y": "xfb577c5e--66bfba--divider",
};

module.exports = exports;
